import { Breadcrumbs } from '@warp-ds/react';
import { useConfig } from 'shared/config/ConfigContext';

type FhhBreadcrumbsProps = {
    className?: string;
    isPreview?: boolean;
};

export const FhhBreadcrumbs = ({ className, isPreview }: FhhBreadcrumbsProps) => {
    const { contextPath } = useConfig();
    const previewOnClick = (e) => {
        e.preventDefault();
        alert('Knapper og lenker er skrudd av under forhåndsvisning');
    };

    return (
        <div className="flex">
            <Breadcrumbs className={`my-24 ${className}`}>
                <a href={isPreview ? '#' : '/reise/'} onClick={isPreview ? previewOnClick : undefined} data-testid="vertical">
                    Reise
                </a>
                <a
                    href={isPreview ? '#' : `${contextPath}/resultat/`}
                    onClick={isPreview ? previewOnClick : undefined}
                    data-testid="submarket">
                    Feriehjem <span className="hidden sm:inline">og hytter til leie</span>
                </a>
            </Breadcrumbs>
        </div>
    );
};
